import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/AkustikPanellerCatalog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/AkustikPanellerFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/node_modules/next/dist/client/link.js");
